// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2xaUY","notes":"Notes_notes__3RXhH","note":"Notes_note__21Meg","markdown":"Notes_markdown__2HD-P"};